import React from 'react';

import { ListWidgetStyleSetting } from '@lumapps/designer-widget-settings/components/ListWidgetStyleSetting';
import { StyleSettingType } from '@lumapps/designer-widget-settings/types';

import { DATA_SCOPE } from '../../constants';
import { TrainingListViewModeType, TrainingListViewModeVariantType } from '../../types';

export interface TrainingListStylesProps {
    className?: string;
    currentStylesSetting?: StyleSettingType<TrainingListViewModeType, TrainingListViewModeVariantType>;
    onChange: (properties: StyleSettingType<TrainingListViewModeType, TrainingListViewModeVariantType>) => void;
}

export const TrainingListStyles: React.FC<TrainingListStylesProps> = ({
    className,
    currentStylesSetting,
    onChange,
}) => (
    <ListWidgetStyleSetting<TrainingListViewModeType, TrainingListViewModeVariantType>
        onChange={onChange}
        currentStylesSetting={currentStylesSetting}
        className={className}
        dataScope={`${DATA_SCOPE}-styles`}
    />
);
